export default __webpack_public_path__ + "static/media/img-0287-zambia-full-face.ed1645bf.png";